<div>

  <!-- Left Sidebar -->

  <aside id="leftsidebar" class="sidebar" (mouseenter)="mouseHover($event)" (mouseleave)="mouseOut($event)">
    <!-- <br> -->
    <!-- <p  class="logo-name" [routerLink]="'/admin/dashboard/main'">Dashboard</p> -->
    <!-- Menu -->
    <div class="menu">
      <ng-scrollbar [style.height]="listMaxHeight + 'px'" visibility="hover">
        <ul class="list">

          <!-- <li class="sidebar-user-panel" style="display: flex;">
          <div class="user-panel">
             <div class=" image">
                <img src={{userImg}} class="img-circle user-img-circle" alt="User Image" />
              </div> 
            </div> 
          <div class="profile-usertitle">
              <div class="sidebar-userpic-name">{{userFullName}} </div>
              <div class="profile-usertitle-job ">{{userType}} </div>
            </div>
          </li> -->

          <!-- cursor: pointer; -->

          <!-- Top Most level menu -->
          <li *ngFor="let sidebarItem of sidebarItems;  let i=index" (click)="select($event,sidebarItem.moduleId)" 
            [routerLinkActive]="sidebarItem.submenu?.length != 0 ? '' : 'active-top'"
            [ngClass]="{'active': selectedIndex == sidebarItem.moduleId}" [attr.data-module-id]="sidebarItem.moduleId">
            <!-- <div class="header" *ngIf="sidebarItem.groupTitle === true && sidebarItem.title === 'Dashboard'" [routerLink]="sidebarItem.path">
              {{sidebarItem.title}}</div> -->
            <div class="super-admin-header" *ngIf="sidebarItem.groupTitle === true && sidebarItem.title != 'Dashboard'" [routerLink]="sidebarItem.path">
              <i [ngClass]="[sidebarItem.icon]"></i> {{sidebarItem.title}}</div>  
            <a [routerLink]="sidebarItem.class != '' ? [sidebarItem.path] : null" *ngIf="!sidebarItem.groupTitle;"
              [ngClass]="[sidebarItem.class]" 
              class="menu-top">
              <!-- <i [ngClass]="[sidebarItem.iconType]">{{sidebarItem.icon}}</i> -->
              <i [ngClass]="[sidebarItem.icon]"></i>
              <span class="hide-menu">{{sidebarItem.title}}
              </span>
              <span *ngIf="sidebarItem.badge != '' " [ngClass]="[sidebarItem.badgeClass]">{{sidebarItem.badge}}</span>
            </a>
            <!-- First level menu -->
            
            <!-- [routerLinkActive]="sidebarSubItem1.submenu.length > 0 ? '' : 'active'" -->
            <ul class="ml-menu" *ngIf="sidebarItem.submenu?.length > 0">
              <li *ngFor="let sidebarSubItem1 of sidebarItem.submenu;let j=index"
                [ngClass]="{'active': selectedIndex1 == j &&  selectedIndex == sidebarItem.moduleId}"
                (click)="select1($event,j,sidebarSubItem1)" >
                <!-- [routerLink]="sidebarSubItem1.submenu.length > 0 ? null : [sidebarSubItem1.path]" -->
                <!-- [routerLink]="sidebarSubItem1.submenu.length > 0 ? null : sidebarSubItem1.path != ''? [sidebarSubItem1.path]:null " -->
                <a [routerLink]="sidebarItem.class != '' ? [sidebarItem.path] : null" *ngIf="!sidebarItem.groupTitle;"
                  (click)="callToggleMenu($event,sidebarSubItem1.submenu?.length,sidebarSubItem1)" 
                  [ngClass]="[sidebarSubItem1?.class !== null ? sidebarSubItem1.class : '']">
                  <i class="submenu-icon" [ngClass]="[sidebarSubItem1?.icon !== null ? sidebarSubItem1.icon : '']"></i>
                   <span>{{sidebarSubItem1.title}}</span>
                </a>
                <!-- Second level menu -->
                <ul class="ml-menu-2" *ngIf="sidebarSubItem1.submenu.length > 0">
                  <li *ngFor="let sidebarSubItem2 of sidebarSubItem1.submenu;let k=index"
                    [routerLinkActive]="sidebarSubItem2.submenu?.length > 0 ? '' : 'active'"
                    [ngClass]="{'active': selectedIndex2 == k && selectedIndex1 == j &&  selectedIndex == sidebarItem.moduleId}"
                    (click)="select2($event,k)">
                    <a [routerLink]="sidebarSubItem2.submenu?.length > 0 ? [sidebarSubItem2.path] :sidebarSubItem2.path !=''? [sidebarSubItem2.path]:null"
                      (click)="callToggleMenu($event,sidebarSubItem2.submenu?.length,sidebarSubItem2)"
                      [ngClass]="[sidebarSubItem2.class]">
                      <span>{{sidebarSubItem2.title}}</span>
                      <i class="submenu-icon" [ngClass]="[sidebarSubItem2.icon ? sidebarSubItem2.icon :'' ]"></i>
                    </a>
                    <!-- Third level menu -->
                    <ul class="ml-menu-3" *ngIf="sidebarSubItem2.submenu.length > 0">
                      <li *ngFor="let sidebarSubItem3 of sidebarSubItem2.submenu"
                        [routerLinkActive]="sidebarSubItem3.submenu?.length > 0 ? '' : 'active'">
                        <a [routerLink]="sidebarSubItem3.submenu?.length > 0 ? null : [sidebarSubItem3.path]"
                          (click)="callToggleMenu($event,sidebarSubItem3.submenu?.length)"
                          [ngClass]="[sidebarSubItem3.class]">
                          {{sidebarSubItem3.title}}
                          <!-- | titlecase | translate -->
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <!-- <li>
            <a class="" (click)="logout()" class="menu-top">
              <i class="material-icons-two-tone">power_settings_new</i>
              <span class="hide-menu">Logout
              </span>
            </a>
          </li> -->
        </ul>
      </ng-scrollbar>
    </div>
    <!-- #Menu -->
  </aside>
  <!-- #END# Left Sidebar -->
</div>